import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

import { ShareMethod } from './ShareRecipientDialog';

// Shown after the PDF has uploaded instead of jumping straight into WhatsApp/Mail on iOS: by then
// several seconds of async work have passed since the user's tap, and iOS Safari ignores scripted
// navigation to an app link (whatsapp://, mailto:) that isn't tied to a fresh tap. A real link the
// user taps here always works.
const ShareLinkDialog = (props: { share: { url: string; method: ShareMethod } | null; onClose: () => void }) => {
  const { share, onClose } = props;
  const label = share?.method === 'email' ? 'Email' : 'WhatsApp';

  return (
    <Dialog open={!!share} onClose={onClose}>
      <DialogTitle>
        <strong>Ready to send</strong>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 280 }}>
        <Typography variant="body2">The floorplans have been uploaded. Tap below to send them via {label}.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {/* Deliberately no onClick close here: clearing `share` re-renders this without an href
            before iOS follows the tap, which cancels the navigation. */}
        <Button variant="contained" color="primary" href={share?.url}>
          Open {label}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareLinkDialog;
